import Component from "../component.abstract"
import { AccountDataInterface } from "@models/account-data";
import BookmarkService from "@services/bookmark-service"
import { AnalyticsEvent } from "@models/analytics-event"

interface BookmarkProps {
    idoffer:string
    idapp: string
}

export default class Bookmark extends Component {
    private service:BookmarkService
    constructor (
        private props: BookmarkProps,
        element: HTMLElement
    ) {  
        super(props, element)
    }

     mounted():void {
        PubSub.subscribe("account-data",(msg:string,data:AccountDataInterface)=>{
            this.loadBookmark(data)
        })
        this.element.addEventListener("click", ()=>{
            this.bookmarkAction();
        })
     }
     loadBookmark(data:AccountDataInterface):void {
        let isBookmarked: string | undefined;
        for (let i = 0; i < data.Bookmarks.length && !isBookmarked; i++) {
            const idBookmark = data.Bookmarks[i];
            if (idBookmark == this.props.idoffer) {
                isBookmarked = idBookmark;
            }

        }
         if (isBookmarked) this.element.classList.add("bookmarked", "fill-error");
     }
     bookmarkAction():void {
        this.element.classList.toggle("bookmarked");
         this.element.classList.toggle("fill-error");
        const bookmarkActionUrl = "/candidat/sauveroffre?idOffre=";
        const url = bookmarkActionUrl + this.props.idoffer +  "&AppId=" + this.props.idapp
        this.service = new BookmarkService(url)
        this.service.get(this.handleResponse.bind(this))
     }
     handleResponse(data:any):void {
         if(data.success) {
            if(data.isAdd) {
                this.setTracking("bookmark_add")
            } else {
                this.setTracking("bookmark_delete")
            }
         } else {
              document.location.href = data.url;
         }
     }
     
    private setTracking(eventName: string): void {
        const tracking: AnalyticsEvent = {
            EventAction: "",
            EventCat: "",
            EventLibelle: "",
            event: "generic",
            EventName: eventName
        }
        window.dataLayer.push(tracking)
    }
}